// extracted by mini-css-extract-plugin
export default {"line":"StepProgress_line__+YnQA","text":"StepProgress_text__v3yEC","elapsed":"StepProgress_elapsed__F3ywm"};